<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <!-- <el-upload
                            :show-file-list="false"
                            :before-upload="beforeUpload"
                            :on-success="onSuccess"
                            :on-error="onError"
                            :disabled="importDataDisabled"
                            style="display: inline-flex;margin-right: 8px"
                            action="/employee/basic/import">
                        <el-button :disabled="importDataDisabled" type="success" :icon="importDataBtnIcon">
                            {{importDataBtnText}}
                        </el-button>
                    </el-upload> -->
                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        新建报销单
                    </el-button>
                </div>
            </div>
            <transition name="slide-fade">
                <div  
                     style="border: 1px solid #409eff;border-radius: 5px;box-sizing: border-box;padding: 5px;margin: 10px 0px;">
                    <el-row>
                        <el-col :span="4">
                            报销单号:
                            <el-input v-model="searchValue.reimbuseName" placeholder="报销单号" clearable size="mini"
                                       style="width: 130px;"></el-input>
                        </el-col>
                        <el-col :span="4">
                            报销状态:
                            <el-select v-model="searchValue.payStatus" clearable="" placeholder="报销状态" size="mini" style="width: 130px;">
                                <el-option
                                        v-for="item in payStatusDic"
                                        :key="item.dictValue"
                                        :label="item.dictLabel"
                                        :value="item.dictValue">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="4" :offset="2">
                            <el-button size="mini">初始化</el-button>
                            <el-button size="mini" icon="el-icon-search" type="primary" @click="initEmps('advanced')">搜索</el-button>
                        </el-col>
                    </el-row>
                </div>
            </transition>
        </div>
        <!-- 标题列 --->
        <div style="margin-top: 10px">
            <el-table
                    :data="emps"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    ref="projectTable"
                    style="width: 100%"
                    :row-key="row=>row.projectCode"
                    @selection-change="handleSelectionChange"
                    :header-cell-style="{'text-align':'center'}">
                   
                <el-table-column
                        prop="reimbuseName"
                        fixed
                        align="left"
                        label="报销单号"
                        width="300">
                </el-table-column>
                <el-table-column
                        prop="totalPrice"
                        width="180"
                        align="center"
                        label="报销金额">
                </el-table-column>
                <el-table-column
                        prop="startTime"
                        width="220"
                        align="center"
                        label="开始时间">
                </el-table-column>
                <el-table-column
                        prop="endTime"
                        width="220"
                        align="center"
                        label="结束时间">
                </el-table-column>
                <el-table-column
                        prop="payStatus"
                        width="120"
                        align="center"
                        label="付款状态">
                        <template slot-scope="scope">
                            {{getChangeType(scope.row.payStatus,'pStatus')}}
                         </template>
                </el-table-column>
                <el-table-column
                        prop="reimbusePersonName"
                        width="140"
                        align="center"
                        label="报销人">
                </el-table-column>
                <el-table-column
                        prop="cTime"
                        width="220"
                        align="center"
                        label="创建时间">
                </el-table-column>               
                
                <el-table-column
                        fixed="right"
                        align="center"
                        width="250"
                        label="操作">
                    <template slot-scope="scope">
                        <!-- <el-button @click="showEditEmpView(scope.row)" v-if="scope.row.subStatus == '0'||user.username=='admin'" style="padding: 3px" size="mini" type="primary">编辑</el-button> -->
                        <el-button @click="showReimbuseDetail(scope.row)"  style="padding: 3px" size="mini" type="primary">明细</el-button>
                        <el-button @click="auditReimbuse(scope.row,1)"  style="padding: 3px" size="mini" type="primary" v-if="scope.row.payStatus == '2'&&user.username=='admin'">审批</el-button>
                        <el-button @click="auditReimbuse(scope.row,0)"  style="padding: 3px" size="mini" type="primary" v-if="scope.row.payStatus == '2'&&user.username=='admin'">驳回</el-button>
                        <el-button @click="commitReimbuse(scope.row)" v-if="scope.row.payStatus == '0'||scope.row.payStatus == '4'" style="padding: 3px" size="mini"  type="success">提交</el-button>
                        <el-button @click="deleteEmp(scope.row)"  v-if="scope.row.subStatus == '0'&&scope.row.totalPrice<=0" style="padding: 3px" size="mini" type="danger">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>

        <el-dialog
                 title="报销明细"
                label-width="80px"
                :visible.sync="showDetail"
                :modal-append-to-body="false"
                :close-on-click-modal="false"
                width="80%">
            <div style="display: flex;justify-content: flex-end;margin-top: 10px;" >
                <div>
                    <el-button v-if="emp.payStatus == '0' ||emp.payStatus == '4'" type="success" style="margin-left: 10px;" @click="addDetail" icon="el-icon-plus">
                        添加明细
                    </el-button>
                </div>
            </div>
        <!-- 明细标题列 --->
            <div style="margin-top: 10px;margin-bottom: 10px;">
                <el-table
                        :data="details"
                        stripe
                        border
                        v-loading="loading"
                        element-loading-text="正在加载..."
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        ref="projectTable"
                        style="width: 100%;"
                        :row-key="row=>row.detailCode"
                        @selection-change="handleSelectionChange"
                        :header-cell-style="{'text-align':'center'}">
                    
                    <el-table-column
                            prop="reimbuseDetailName"
                            fixed
                            align="center"
                            label="费用名称"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="payPrice"
                            align="center"
                            label="金额"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="payTime"
                            align="center"
                            label="发生时间"
                            width="160">
                    </el-table-column>
                    <el-table-column
                            prop="pName"
                            align="center"
                            label="涉及项目"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="payImage"
                            align="center"
                            label="报销凭证"
                            width="280">
                        <template slot-scope="scope" >
                           <el-popover
                                placement="top-start"
                                trigger="hover"
                                >
                                <el-image
                                style="max-width: 300px;max-height: 500px;"
                                    :src="scope.row.payImageUrl"
                                    :preview-src-list="scope.row.srcList"
                                />
                                <span style="color: #409eff;" slot="reference">{{scope.row.payImage}}</span>
                            </el-popover>
                            <!-- <el-popover placement="right" :width="400" trigger="hover">
                                <img :src="scope.row.payImageUrl" width="400" height="400" />
                                <template #reference>
                                <img
                                    :src="scope.row.picUrl"
                                    style="max-height: 60px; max-width: 60px"
                                />
                                </template>
                            </el-popover> -->
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="reimbusePersonName"
                            align="center"
                            label="报销人"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="cTime"
                            align="center"
                            label="创建时间"
                            width="160">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            align="center"
                            width="200"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button @click="putDetail(scope.row)" v-if="emp.payStatus == '0' ||emp.payStatus == '4'" style="padding: 3px" type="primary" size="mini">编辑</el-button>
                            <el-button v-if="scope.row.needPayImage == '1'" style="padding: 3px" type="primary" size="mini">
                                <el-upload  
                                action="/yl/reimbuse/upload"
                                :data={reimpuseDetailCode:scope.row.reimbuseDetailCode}
                                :show-file-list="false"
                                :multiple="false"
                                :on-success="onSuccessImg"
                                 >上传凭证
                                </el-upload>
                            </el-button>
                            
                            <el-button @click="deleteDetail(scope.row)" v-if="emp.payStatus == '0' ||emp.payStatus == '4'" style="padding: 3px" size="mini" type="danger">删除
                            </el-button>
                            
                        </template>
                    </el-table-column>
                </el-table>
            </div>


        </el-dialog>
        <el-dialog
                 :title="detailTitle"
                label-width="80px"
                :modal-append-to-body="false"
                :close-on-click-modal="false"
                :visible.sync="showChangeDetail"  
                width="30%"
                >
                <el-form :model="detail" label-position="right" label-width="120px" :rules="rules" ref="empForm1">
                            <el-form-item label="费用名称:" prop="reimbuseDetailName">
                                <el-input size="mini" style="width: 180px" prefix-icon="el-icon-edit" v-model="detail.reimbuseDetailName"
                                          placeholder="请输入费用名称"></el-input>
                            </el-form-item>
                            <el-form-item label="报销金额:" prop="payPrice">
                                <el-input size="mini" style="width: 180px" prefix-icon="el-icon-edit" v-model="detail.payPrice"
                                          placeholder="金额，支持小数点后两位"></el-input>
                            </el-form-item>
                            <el-form-item label="所属项目:" prop="pCode">
                                <el-select size="mini" style="width: 180px" v-model="detail.pCode" filterable  @change="$forceUpdate()"  placeholder="请选择">
                                    <el-option 
                                            v-for="(r,indexk) in projects"
                                            :key="r.pCode"
                                            :label="r.pName"
                                            :value="r.pCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="payTime"  label="费用发生时间:">
                                <el-date-picker style="width: 180px"
                                        v-model="detail.payTime"
                                        type="date"
                                        size="mini"
                                        @input="$forceUpdate()" 
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        placeholder="费用发生时间">
                                </el-date-picker>
                            </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="showChangeDetail = false">取 消</el-button>
                    <el-button type="primary" @click="doAddDetail">确 定</el-button>
                </span>
            </el-dialog>


        <!-- 上传项目文件弹窗 -->
        <!--================================上传文件弹窗=========================-->
        <el-dialog :title="addFileTitleName"  :modal-append-to-body="false" :close-on-click-modal="false" :visible.sync="importDataDisabled" width="500px" style="padding:0;" @close="resetAddFile" >
             <div class="add-file-right" >
                <el-col :span="24">
                    下单平台:<el-select v-model="upFilePlat" clearable="" placeholder="下单平台" size="mini">
                        <el-option
                                v-for="item in platList"
                                :key="item.dictValue"
                                :label="item.dictLabel"
                                :value="item.dictValue">
                        </el-option>
                    </el-select>
                </el-col>
            </div>
            <!-- <el-input v-model="addFileName" autocomplete="off" size="small" style="width: 300px; display: none;" ></el-input> -->
           
            <div class="add-file-right" style="margin-top: 20px;">
                <input type="file" ref="clearFile" @change="getFile($event)" multiple="multiplt" class="add-file-right-input" style="margin-left:60px;margin-top: 20px;" accept=".xlsx">
                <div style="margin-top: 20px;">
                    <span class="add-file-right-more">支持扩展名：.xlsx</span>
                </div>
                <div style="margin-top: 10px;">
                    <span class="add-file-right-more">注意：表中必须含有"项目名称"字段,前程和销售单需要注意</span>
                </div>
            </div>
            <div class="add-file-list">
                <ul>
                    <li v-for="(item, index) in addArr" :key="index"><a >{{item.name}}</a></li>
                </ul>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddFile" size="small">开始上传</el-button>
                <el-button @click="resetAddFile" size="small">全部删除</el-button>
            </div>
            
        </el-dialog>


        <el-dialog
                :title="title"
                :modal-append-to-body="false"
                :close-on-click-modal="false"
                :visible.sync="dialogVisible"
                width="20%">
            <div style="display: flex;justify-content: center;">
                <el-form :model="emp" :rules="rules" ref="empForm">
                    <el-form-item prop="startTime">
                        <el-date-picker
                                v-model="emp.startTime"
                                type="date"
                                size="mini"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                placeholder="报销单开始时间">
                        </el-date-picker>
                    </el-form-item>
                    <span style="margin: 0 18px 18px 18px;"> - </span>
                    <el-form-item  prop="endTime">
                        <el-date-picker
                                v-model="emp.endTime"
                                type="date"
                                size="mini"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                :picker-options="{
                                    disabledDate: (time) => {
                                        if(this.emp.startTime){
                                            return time.getTime() <= new Date(this.emp.startTime).getTime()  
                                        }
                                    }
                                }"
                                placeholder="报销单结束时间">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="doAddEmp">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
    import {Message} from 'element-ui';
    export default {
        name: "projectInfo",
        data() {
            return {
               
                searchValue: {
                    reimbuseName:null,
                    reimbusePersonId:null,
                    beginDateScope: null
                },
                typeList: [ ],
                platList: [ ],
                sourceList: [
                    {
                        dictValue: '01',
                        dictLabel: '自然流量'
                    }, 
                    {
                        dictValue: '02',
                        dictLabel: '销售引入'
                    }
                ],
                payStatusDic: [
                    {
                        dictValue: '0',
                        dictLabel: '未提交'
                    }, 
                    {
                        dictValue: '1',
                        dictLabel: '待传凭证'
                    }, 
                    {
                        dictValue: '2',
                        dictLabel: '待审批'
                    }, 
                    {
                        dictValue: '3',
                        dictLabel: '待付款'
                    }, 
                    {
                        dictValue: '4',
                        dictLabel: '审核不通过'
                    }, 
                    {
                        dictValue: '5',
                        dictLabel: '报销完成'
                    }
                ],
                title: '',
                importDataBtnText: '导入数据',
                importDataBtnIcon: 'el-icon-upload2',
                importDataDisabled: false,
                showAdvanceSearchView: false,
                allDeps: [],
                fileList1: [],
                detailTitle: '',
                user:{},
                upFilePlat:'',
                addFileTitleName: "上传文件窗口",
                addFileName: "",
                addArr: [],
                emps: [],
                details:[],
                reimbuseCode:'',
                detail:{},
                loading: false,
                popVisible: false,
                popVisible2: false,
                dialogVisible: false,
                showDetail: false,
                showChangeDetail: false,
                total: 0,
                projects:[],
                page: 1,
                keyword: '',
                size: 10,
                nations: [],
                joblevels: [],
                politicsstatus: [],
                positions: [],
                emp: {
                    startTime:'',
                    endTime:'',
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rules: {
                    name: [{required: true, message: '请输入用户名', trigger: 'blur'}],
                    gender: [{required: true, message: '请输入性别', trigger: 'blur'}],
                    birthday: [{required: true, message: '请输入出生日期', trigger: 'blur'}],
                    idCard: [{required: true, message: '请输入身份证号码', trigger: 'blur'}, {
                        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: '身份证号码格式不正确',
                        trigger: 'blur'
                    }],
                    wedlock: [{required: true, message: '请输入婚姻状况', trigger: 'blur'}],
                    nationId: [{required: true, message: '请输入您组', trigger: 'blur'}],
                    nativePlace: [{required: true, message: '请输入籍贯', trigger: 'blur'}],
                    politicId: [{required: true, message: '请输入政治面貌', trigger: 'blur'}],
                    email: [{required: true, message: '请输入邮箱地址', trigger: 'blur'}, {
                        type: 'email',
                        message: '邮箱格式不正确',
                        trigger: 'blur'
                    }],
                    workAge: [{required: true, message: '请输入工龄', trigger: 'blur'}],
                }
            }
        },
        mounted() {
            this.initData();
            this.initEmps();
        },
        methods: {
            addToSrcList(data){
                data.srcList = [];
                data.srcList.push(data.payImageUrl);
            },
            searvhViewHandleNodeClick(data) {
                this.inputDepName = data.name;
                this.searchValue.departmentId = data.id;
                this.popVisible2 = !this.popVisible2
            },
            rowKey(row){
                console.log( row.projectCode)
                row.projectCode;
            },
            handleSelectionChange (val) {
                console.log(val)
            },
            //1、使用插槽（推荐）
            getChangeType(e,z) {

                if('type' == z){
                    for (var i = 0; i < this.typeList.length; i++) {
                        if (this.typeList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.typeList[i].dictLabel;
                        }
                    }
                }else if('plat' == z){
                    for (var i = 0; i < this.platList.length; i++) {
                        if (this.platList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.platList[i].dictLabel;
                        }
                    }
                }else if('source' == z){
                    for (var i = 0; i < this.sourceList.length; i++) {
                        if (this.sourceList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.sourceList[i].dictLabel;
                        }
                    }
                }else if('pStatus' == z){
                    for (var i = 0; i < this.payStatusDic.length; i++) {
                        if (this.payStatusDic[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                            return this.payStatusDic[i].dictLabel;
                        }
                    }
                }
               
            },

            onError(err, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
            },
            onSuccessImg(res, file){
                Message.success({message:  '上传成功'})
                this.initDetails();
            },
            onSuccess(response, file, fileList) {
                this.importDataBtnText = '导入数据';
                this.importDataBtnIcon = 'el-icon-upload2';
                this.importDataDisabled = false;
                this.initEmps();
            },
            beforeUpload() {
                this.importDataBtnText = '正在导入';
                this.importDataBtnIcon = 'el-icon-loading';
                this.importDataDisabled = true;
            },
            importData(){
                this.importDataDisabled = true;
            },
            exportData() {
                let a = this.$refs.projectTable.selection
                window.open('/employee/basic/export', '_parent');
            },
            exportTask() {
                let selected = this.$refs.projectTable.selection
                let arr = [];
                for(let temp in selected){
                    arr.push(selected[temp].projectCode)

                }
                window.open('/employee/basic/export', '_parent');
            },
            emptyEmp() {
                this.emp = {
                    startTime:'',
                    endTime:'',
                }
                this.inputDepName = '';
            },
            emptyDetail(data){
                if(data == 'abs'){
                    this.detail = {
                    } 
                }else{
                    var detailTemp = JSON.parse(JSON.stringify(this.detail));
                    this.detail = {
                    } 
                    this.detail.pCode = detailTemp.pCode;
                    this.detail.payTime = detailTemp.payTime;
                }
                
            },
            showEditEmpView(data) {
                this.title = '修改报销时间';
                this.emp = data;
                // this.inputDepName = data.department.name;
                this.dialogVisible = true;
            },
            deleteDetail(data){
                this.$confirm('此操作将永久删除【' + data.reimbuseDetailName + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/yl/reimbuse/detail/" + data.reimbuseDetailCode).then(resp => {
                        if (resp) {
                            this.initDetails();
                            this.initEmps();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

            deleteEmp(data) {
                this.$confirm('此操作将永久删除【' + data.reimbuseName + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/yl/reimbuse/" + data.reimbuseCode).then(resp => {
                        if (resp) {
                            this.initEmps();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            doAddEmp() {
                if (this.emp.id) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.putRequest("/yl/reimbuse", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                } else {
                    this.emp.reimbusePersonName = this.user.name
                    this.emp.reimbusePersonId = this.user.username
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/yl/reimbuse", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                }
            },
            commitReimbuse(data){
                this.getRequest('/yl/reimbuse/commit/'+data.reimbuseCode).then(resp => {
                    if (resp) {
                        this.initEmps();
                    }
                })
            },

            auditReimbuse(data,z){
                this.getRequest('/yl/reimbuse/audit/'+z+data.reimbuseCode).then(resp => {
                    if (resp) {
                        this.initEmps();
                    }
                })
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            showReimbuseDetail(data){
                this.showDetail = true;
                this.detail.reimbuseCode = data.reimbuseCode;
                this.reimbuseCode = data.reimbuseCode;
                this.emp = data;
                this.initDetails();
            },

            initDetails(){
                this.getRequest("/yl/reimbuse/detail/"+this.reimbuseCode).then(resp => {
                    if (resp) {
                        for(var index in resp.data){
                            this.addToSrcList(resp.data[index]);
                        }
                        this.details = resp.data;
                    }
                })
            },
            addDetail(){
                this.detailTitle = '添加明细';
                this.showChangeDetail = true;
                this.getRequest("/yl/offline/allProject").then(resp => {
                                if (resp) {
                                    this.projects = resp.data;
                                }
                            })
            },
            putDetail(data){
                this.detailTitle = '修改明细';
                this.showChangeDetail = true;
                this.detail = data;
                this.getRequest("/yl/offline/allProject").then(resp => {
                                if (resp) {
                                    this.projects = resp.data;
                                }
                            })
            },
            doAddDetail() {
                if (this.detail.id) {
                    this.$refs['empForm1'].validate(valid => {
                        if (valid) {
                            this.putRequest("/yl/reimbuse/detail", this.detail).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                    this.initDetails();
                                }
                            })
                        }
                    });
                    this.emptyDetail('abs');
                } else {
                    this.detail.reimbuseCode = this.reimbuseCode;
                    this.detail.reimbusePersonName = this.user.name
                    this.detail.reimbusePersonId = this.user.username
                    this.$refs['empForm1'].validate(valid => {
                        if (valid) {
                            this.postRequest("/yl/reimbuse/detail", this.detail).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                    this.initDetails();
                                }
                            })
                        }
                    });
                }
                this.showChangeDetail = false;
                this.emptyDetail();
                
            },

            initData() {
                this.user = JSON.parse(window.sessionStorage.getItem("user"));
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '创建报销单';
                this.dialogVisible = true;
            },
            initEmps(type) {
                this.loading = true;
                // let reqParam = {projectNameLike:this.keyword};
                this.searchValue['pageNo']=this.page
                this.searchValue['pageSize']=this.size
                this.searchValue['reimbusePersonId'] = this.user.username
                this.postRequest('/yl/reimbuse/getReimbuse', this.searchValue).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                    }
                });
            },
            //==================上传文件操作函数=============================================
            getFile(event){  
                //获取上传文件方法    
                var file = event.target.files;    
                for(var i = 0;i<file.length;i++){        
                    //    上传类型判断        
                    var imgName = file[i].name;        
                    var idx = imgName.lastIndexOf(".");        
                    if (idx != -1){            
                        var ext = imgName.substr(idx+1).toUpperCase();            
                        ext = ext.toLowerCase( );            
                        //pdg,doc,docx.xls,.xlsx,.ppt,pptx,            
                        if (ext!='xlsx'){

                        }else{
                            this.addArr.push(file[i]);            
                        }        
                    }else{        

                    }    
                }},
            submitAddFile(){    
                //===========提交上传文件到后台保存方法    
                if(0 == this.addArr.length){        
                    this.$message({            
                        type: 'info',            
                        message: '请选择要上传的文件'        
                    });        
                    return;    
                }    
                var formData = new FormData();    
                for(var i=0;i<this.addArr.length;i++){        
                    formData.append('files',this.addArr[i]); 
                }  
                formData.append('plat',this.upFilePlat);      
                let config = {        
                    headers: { "Content-Type": "multipart/form-data" }    
                };    
                console.log(formData);　　
                //接口请求使用的是自己封装了一下的axios    
                this.postRequest('/yl/qun/importProject', formData, config).then(res => {
                    console.log(res);        
                    this.$message({            
                        message: '操作成功',            
                        type: 'success'        
                    });    
                }).catch((error) => {        
                    alert("操作失败，出现错误：" + error)    
                });
            },
            //清除上传的文件方法
            resetAddFile(){   
                this.addFileName = "";    
                this.addArr =[];
                this.upFilePlat = "";
                this.$refs.clearFile.value =''
            },

        }
    }
</script>

<style>
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }
    .el-form-item{
        margin-bottom: 0px !important;
    }
    .el-table__fixed,.el-table__fixed-right{
        height: 100% !important;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .el-upload{
        color:white !important;
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>
